function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
const navLinkClasses = cva([
    'text-sm',
    'font-semibold',
    'inline-block',
    'after:block',
    'after:transform',
    'after:transition-all',
    'after:h-[3px]',
    'after:bg-primary',
    'after:ease-in',
    'after:origin-center',
    'after:duration-200',
    'outline-0'
], {
    variants: {
        active: {
            true: [
                'after:scale-x-100',
                'after:opacity-100'
            ],
            false: [
                'after:scale-x-90',
                'after:opacity-0',
                'hover:after:opacity-50',
                'hover:after:scale-x-100',
                'focus-visible:after:scale-x-100',
                'focus-visible:after:opacity-50'
            ]
        }
    }
});
/**
 * Nav Item - [API](https://scl.sharp.com/?path=/docs/navigation-navbar) | [DSM](https://sharphealthcare.notion.site/Nav-bar-block-6539fc3170b34389b3ba1979c9043bfe)
 *
 * This component is meant to be nested inside of `<NavBar />` and `<Header />`.
 */ const NavItem = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { as: Component = 'a', active = false, className, label, children } = _param, props = _object_without_properties(_param, [
        "as",
        "active",
        "className",
        "label",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(navLinkClasses({
            active,
            className
        })),
        children: label !== null && label !== void 0 ? label : children
    }));
});
export { NavItem };
